import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription }   from 'rxjs/Subscription';
import { AuthService } from '../../../providers/auth.service';


export class NavbarComponent implements OnInit, OnDestroy {
	public navUserType: string;
	public navigationTypeSubscription: Subscription;

	constructor(private authService: AuthService) { }

	public ngOnInit() {
		this.navigationTypeSubscription = this.authService.userType$.subscribe(
			(userType) => {
				this.navUserType = userType;
			}
		);
	}

	public ngOnDestroy() {
		this.navigationTypeSubscription.unsubscribe();
	}
static ctorParameters() { return [ { type: AuthService } ]; }}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/shared/navbar/navbar.component.ts